var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccord2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 73,
    viewBox: "0 0 70 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M0 8H70",
    stroke: "#FDEAE5",
    strokeWidth: 15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M0 37H70",
    stroke: "#FDEAE5",
    strokeWidth: 15
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M0 65H54",
    stroke: "#FDEAE5",
    strokeWidth: 15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccord2);
export default __webpack_public_path__ + "static/media/accord_2.dd0ce9a8fa2d3d79e28b23de0cef2dbc.svg";
export { ForwardRef as ReactComponent };